import treatments from '../Assets/Icons/Statuses/pill.png';
import cardiovascular_diseases from '../Assets/Icons/Statuses/CardioVascular.png';
import respiratory_diseases from '../Assets/Icons/Statuses/Respiratory.png';
import diabetes from '../Assets/Icons/Statuses/Diabetes.png';
import kidney_diseases from '../Assets/Icons/Statuses/Kidney.png';
import neurological_disorders from '../Assets/Icons/Statuses/neurological.png';
import cancer from '../Assets/Icons/Statuses/Taurus-Zodiac.png';
import musculoskeletal_disorders from '../Assets/Icons/Statuses/Taurus-Zodiac.png';
import autoimmune_diseases from '../Assets/Icons/Statuses/Taurus-Zodiac.png';
import metabolic_disorders from '../Assets/Icons/Statuses/Taurus-Zodiac.png';
import digestive_system_disorders from '../Assets/Icons/Statuses/Taurus-Zodiac.png';
import mental_health_conditions from '../Assets/Icons/Statuses/Taurus-Zodiac.png';
import infectious_diseases from '../Assets/Icons/Statuses/Taurus-Zodiac.png';
import skin_conditions from '../Assets/Icons/Statuses/Taurus-Zodiac.png';



const iconsChronicCategories = {
    0: treatments,
    1: cardiovascular_diseases,
    2: respiratory_diseases,
    3: diabetes,
    4: kidney_diseases,
    5: neurological_disorders,
    6: cancer,
    7: musculoskeletal_disorders,
    8: autoimmune_diseases,
    9: metabolic_disorders,
    10: digestive_system_disorders,
    11: mental_health_conditions,
    12: infectious_diseases,
    13: skin_conditions,
  };
  
  export default iconsChronicCategories;